export enum AnalysisType {
    Distance = "Distance",
    WalkTime = "WalkTime",
    FlowRate = "FlowRate",
    Area = "Area",
    Capacity = "Capacity",
    Count = "Count"
}